import styled from 'styled-components'
export const TopBlogOuter = styled.div`
  padding: 48px 0 64px 0;
  background: ${p => p.theme.webMktPalette.background.gray};
  ${p => p.theme.breakpoints.down('sm')} {
    padding: 16px 0 12px 0;
  }
`
export const TopBlogSection = styled.div`
  .TopBlog__Primary {
    display: flex;
    flex-direction: column;
    &:hover {
      .TopBlog__Primary-Article-Title {
        color: rgb(0, 103, 223);
      }
    }
  }
  .TopBlog__Primary-Robot-Img {
    position: absolute;
  }
  .TopBlog__Primary-Img-Robot {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    &:after {
      content: '';
      background-image: radial-gradient(rgb(59, 59, 59) 1px, transparent 0);
      position: absolute;
      width: 442px;
      height: 280px;
      z-index: 0;
      top: 71px;
      right: 0;
      background-size: 24px 24px;
      ${p => p.theme.breakpoints.down('md')} {
        height: 235px;
        width: 452px;
        top: 48px;
      }
      ${p => p.theme.breakpoints.down('sm')} {
        height: 275px;
        width: 532px;
        top: 64px;
      }
      ${p => p.theme.breakpoints.down('xs')} {
        height: 152px;
        width: 258px;
        bottom: -35px;
        right: -16px;
        top: unset;
      }
    }
    &:before {
      content: '';
      background-image: url('https://images.ctfassets.net/5965pury2lcm/5iIyErbWLtmjny2WrxInm6/6de257cd4488be92acba0c7304cb0ea1/Macaroni-White.png');
      position: absolute;
      width: 760px;
      height: 358px;
      z-index: 1;
      top: 63px;
      left: 0;
      background-size: contain;
      background-repeat: no-repeat;
      opacity: 80%;
      ${p => p.theme.breakpoints.down('md')} {
        height: 317px;
        width: 633px;
        top: 14px;
      }
      ${p => p.theme.breakpoints.down('sm')} {
        height: 342px;
        width: 737px;
        top: 0;
      }
      ${p => p.theme.breakpoints.down('xs')} {
        display: none;
      }
    }
  }
  .TopBlog__Primary-Img-Container {
    height: 295px;
    ${p => p.theme.breakpoints.down('md')} {
      height: 235px;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      height: 275px;
    }
    @media screen and (max-width: 360px) {
      height: 165px;
    }
  }
  .TopBlog__Primary-Img-Container,
  .TopBlog__Primary-Article-Txt-Container {
    width: 590px;
    margin-left: auto;
    margin-right: auto;
    ${p => p.theme.breakpoints.down('md')} {
      width: 467px;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      width: 546px;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      width: 100%;
      max-width: 546px;
    }
  }
  .TopBlog__Primary-Img,
  .TopBlog__Primary-Article-Txt-Container {
    z-index: 3;
  }
  .TopBlog__Primary-Article-Date {
    margin: 24px auto;
    color: ${p => p.theme.webMktPalette.text.secondary};
    ${p => p.theme.breakpoints.down('xs')} {
      margin: 16px auto;
    }
  }
  .TopBlog__Primary-Img {
    height: 100%;
    width: auto;
    min-width: 100%;
    object-fit: cover;
    position: relative;
  }
  .TopBlog__Primary-Robot-Img {
    width: 178px;
    height: 153px;
    bottom: 23px;
    z-index: 3;
    ${p => p.theme.breakpoints.down('md')} {
      height: 120px;
      width: 140px;
      bottom: 0;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      height: 147px;
      width: 172px;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      display: none;
    }
  }
  .TopBlog__Primary-Article-Title {
    margin: 0;
    font-size: 44px;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    letter-spacing: -2px;
    line-height: 48px;
    transition: 0.1s all cubic-bezier(0.4, 0, 0.2, 1);
    ${p => p.theme.breakpoints.down('md')} {
      font-size: 40px;
      line-height: 44px;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      font-size: 28px;
      letter-spacing: 0px;
      line-height: 36px;
    }
  }
  .TopBlog__Primary-Article-Subtitle {
    margin: 24px 0 0 0;
    ${p => p.theme.breakpoints.down('xs')} {
      margin: 16px 0 0 0;
    }
  }
  .TopBlog__Secondary {
    ${p => p.theme.breakpoints.down('sm')} {
      max-width: 546px;
      margin: 24px auto 0 auto;
      width: 100%;
    }
  }
  .TopBlog__Secondary-Article {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
    .TopBlog__Secondary-Article-Title {
      transition: 0.1s all cubic-bezier(0.4, 0, 0.2, 1);
    }
    &:hover {
      .TopBlog__Secondary-Article-Title {
        color: rgb(0, 103, 223);
      }
    }
    .TopBlog__Secondary-Article-Img-Container {
      height: 80px;
      width: 80px;
      min-width: 80px;
      margin-right: 24px;
      ${p => p.theme.breakpoints.down('md')} {
        height: 78px;
        width: 78px;
        min-width: 78px;
      }
      @media screen and (max-width: 360px) {
        margin-right: 16px;
      }
      .TopBlog__Secondary-Img {
        width: 100%;
        height: auto;
        min-height: 100%;
        object-fit: cover;
      }
      &--Subscribe {
        background: #1e1e1e;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .TopBlog__Secondary-Img {
          height: auto;
          width: 32px;
          object-fit: contain;
        }
      }
    }
    .TopBlog__Secondary-Article-Txt-Container {
      max-width: 282px;
      width: 100%;
      ${p => p.theme.breakpoints.down('md')} {
        max-width: 202px;
      }
      ${p => p.theme.breakpoints.down('sm')} {
        max-width: 446px;
      }
      .TopBlog__Secondary-Article-Txt-Category-Date {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        flex-wrap: wrap;
        .TopBlog__Secondary-Article-Category {
          color: ${p => p.theme.webMktPalette.text.secondary};
          margin: 0;
        }
        .TopBlog__Secondary-Article-Date {
          color: rgba(0, 0, 0, 0.3);
          margin: 0;
        }
      }
    }
  }
`

export const SecodaryBlogHeroWrapper = styled.div`
  .Secondary__Blog__Hero-Img-Container {
    position: relative;
  }

  .Secondary__Blog__Hero-Bottom-Articles {
    padding-top: 148px;
    ${p => p.theme.breakpoints.down('md')} {
      padding-top: 178px;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      padding: 16px;
    }
  }

  .TopBlog__Secodary-Robot-Img {
    width: 180px;
    height: 128px;
    z-index: 3;
    position: absolute;
    top: -62px;
    right: 0px;

    ${p => p.theme.breakpoints.down('md')} {
      height: 120px;
      width: 140px;
      bottom: 0;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      height: 122px;
      width: 171px;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      height: 60px;
      width: auto;
      top: -30px;
    }
  }

  .Secondary__Blog__TopBlog__Primary {
    display: flex;
    flex-direction: column;
    /* &:hover {
      .TopBlog__Primary-Article-Title {
        color: rgb(0, 103, 223);
      }
    } */
  }

  .SecondaryBlog_Primary-Article-Txt-Container {
    z-index: 3;
    width: 587px;
    min-height: auto;
    background-color: ${p => p.theme.webMktPalette.background.dark};
    padding: 48px;
    align-self: flex-end;
    box-sizing: border-box;
    position: absolute;
    bottom: -100px;
    ${p => p.theme.breakpoints.down('md')} {
      width: 550px;
      bottom: -130px;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      width: 548px;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      padding: 16px;
      width: 100%;
      box-sizing: border-box;
      position: relative;
      bottom: auto;
    }

    .TopBlog__Primary-Article-Title,
    .TopBlog__Primary-Article-Date,
    .TopBlog__Primary-Article-Subtitle,
    .TopBlog__Primary-Article-CategoryTitle {
      color: ${p => p.theme.webMktPalette.text.primaryWhite};
      margin-bottom: 24px;
    }

    .TopBlog__Primary-Article-Button {
      color: ${p => p.theme.webMktPalette.text.actionDark};
    }

    .TopBlog__Primary-Article-Title {
      font-size: 36px;
      line-height: 44px;

      ${p => p.theme.breakpoints.down('md')} {
        font-size: 32px;
        line-height: 36px;
      }
      ${p => p.theme.breakpoints.down('sm')} {
        font-size: 26px;
        letter-spacing: 0px;
        line-height: 32px;
      }
      ${p => p.theme.breakpoints.down('xs')} {
        font-size: 22px;
        line-height: 28px;
      }
    }
  }

  .TopBlog__Secondary-Article {
    margin-right: 22px;
  }

  // background macaroni
  .Secondary__Blog__Hero-Img-Container {
    &:after {
      content: '';
      background-image: radial-gradient(rgb(59, 59, 59) 1px, transparent 0);
      position: absolute;
      width: 442px;
      height: 136px;
      z-index: 0;
      top: 97px;
      right: 245px;
      background-size: 24px 24px;
      ${p => p.theme.breakpoints.down('md')} {
        top: 97px;
        right: 245px;
      }
      ${p => p.theme.breakpoints.down('sm')} {
        height: 275px;
        width: 532px;
        top: 110px;
        right: -31px;
      }
      ${p => p.theme.breakpoints.down('xs')} {
        display: none;
      }
    }
    &:before {
      content: '';
      background-image: radial-gradient(rgb(59, 59, 59) 1px, transparent 0);
      position: absolute;
      width: 800px;
      height: 136px;
      z-index: 1;
      top: 345px;
      left: 5px;
      background-size: 24px 24px;
      ${p => p.theme.breakpoints.down('md')} {
        width: 442px;
        top: 266px;
        left: 5px;
      }
      ${p => p.theme.breakpoints.down('xs')} {
        display: none;
      }
    }
  }

  .TopBlog__Secondary-Img-Container {
    &:before {
      content: '';
      background-image: url('https://images.ctfassets.net/5965pury2lcm/5iIyErbWLtmjny2WrxInm6/6de257cd4488be92acba0c7304cb0ea1/Macaroni-White.png');
      position: absolute;
      width: 760px;
      height: 358px;
      z-index: 0;
      top: 0;
      right: -369px;
      background-size: contain;
      background-repeat: no-repeat;
      opacity: 80%;
      transform: rotate(180deg);
      ${p => p.theme.breakpoints.down('md')} {
        height: 317px;
        width: 633px;
        top: -52px;
        right: -237px;
      }
      ${p => p.theme.breakpoints.down('sm')} {
        display: none;
      }
    }

    &::after {
      content: '';
      background-image: url('https://images.ctfassets.net/5965pury2lcm/3rUXDMGbtk3yn8Y594DVD4/e48477aa550f6ceb81602e9f6bd4decd/Path.png');
      position: absolute;
      width: 192px;
      height: 192px;
      z-index: 0;
      bottom: -76px;
      left: 14px;
      background-size: contain;
      background-repeat: no-repeat;
      opacity: 80%;
      ${p => p.theme.breakpoints.down('md')} {
        left: -20px;
      }
      ${p => p.theme.breakpoints.down('sm')} {
        display: none;
      }
    }
  }

  .SecondaryBlog_Primary-Article-Txt-Container {
    &:before {
      content: '';
      background-image: radial-gradient(rgb(59, 59, 59) 1px, transparent 0);
      position: absolute;
      width: 500px;
      height: 136px;
      z-index: 1;
      top: -204px;
      right: -639px;
      background-size: 24px 24px;
      ${p => p.theme.breakpoints.down('md')} {
        display: none;
      }
    }
    &:after {
      content: '';
      background-image: radial-gradient(rgb(59, 59, 59) 1px, transparent 0);
      position: absolute;
      width: 500px;
      height: 136px;
      z-index: 1;
      top: -162px;
      left: -1225px;
      background-size: 24px 24px;
      ${p => p.theme.breakpoints.down('md')} {
        display: none;
      }
    }
  }

  .TopBlog__Primary-Article-CategoryTitle {
    &:after {
      content: '';
      background-image: url('https://images.ctfassets.net/5965pury2lcm/5iIyErbWLtmjny2WrxInm6/6de257cd4488be92acba0c7304cb0ea1/Macaroni-White.png');
      position: absolute;
      width: 760px;
      height: 358px;
      z-index: 0;
      top: -272px;
      right: 1137px;
      background-size: contain;
      background-repeat: no-repeat;
      opacity: 80%;
      transform: rotate(90deg);
      ${p => p.theme.breakpoints.down('md')} {
        display: none;
      }
    }
  }
`

export const SecondaryHeroImageWrapper = styled.div`
  img.TopBlog__Secondary-Img {
    height: 396px;
    width: auto;
    max-width: 792px;
    max-height: 396px;
    object-fit: cover;
    position: relative;
    z-index: 3;

    ${p => p.theme.breakpoints.down('md')} {
      height: 317px;
    }

    ${p => p.theme.breakpoints.down('sm')} {
      height: 321px;
    }

    ${p => p.theme.breakpoints.down('xs')} {
      width: 100%;
      height: 100%;
    }
  }
`
